<template>
  <!-- Schaltungstyp-Icon wie die Jira-Arbeitstyp-Icons: 16-px-Quadrat mit Symbol. -->
  <span class="mb-typeicon" :class="code || 'none'" :title="TITLES[code] || ''" aria-hidden="true">
    <i :class="['fas', ICONS[code] || 'fa-circle']" />
  </span>
</template>

<script setup>
defineProps({
  code: { type: String, default: '' }
});

const ICONS = { intern: 'fa-house', konzern: 'fa-building', gegengeschaeft: 'fa-handshake' };
const TITLES = { intern: 'Interne Schaltung', konzern: 'Konzernschaltung', gegengeschaeft: 'Gegengeschäft' };
</script>
